export default __webpack_public_path__ + "static/media/arrow.7bf783c1.svg";